import { Directive, HostBinding } from '@angular/core';

@Directive({
  // tslint:disable:directive-selector
  selector: 'a[ls-link]'
})
export class LinkDirective {
  @HostBinding('class.cr-text-link') public link = true;
}
